import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ChatState } from '../../models/chat.state';

export const selectChatState = createFeatureSelector<ChatState>('chat');

export const selectIsLoading = createSelector(
  selectChatState,
  (state) => state.isLoading
);

export const selectMessages = createSelector(
  selectChatState,
  (state) => state.messages
);

export const selectLastMessage = createSelector(
  selectMessages,
  (messages) => messages[messages.length - 1]
);

export const selectCurrentMessage = createSelector(
  selectChatState,
  (state) => state.currentMessage,
);

export const selectMediaUploadDetails = createSelector(
  selectChatState,
  (state) => state.mediaUploadDetails
);

export const selectMediaMessage = createSelector(
  selectChatState,
  (state) => state.mediaMessage
);

export const selectFile = createSelector(
  selectChatState,
  (state) => state.mediaFile
)

export const selectPendingMessages = createSelector(
  selectChatState,
  (state: ChatState) => state.pendingMessages
);